module.exports = __webpack_public_path__ + "static/media/BannerD14.eea7a0b9.png";